import { useEffect, useRef, useState } from "react";
import { AlertCircle, Globe, Search } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addDeductItem,
  deductionItemById,
  deductionItemByName,
  searchDeductItems,
  updateDeductItem,
} from "../../api/DeductionItemApi";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import DeductionItemForm from "../../components/master/deduction/DeductionItemForm";
import ItemTaxForm from "../../components/master/deduction/ItemTaxForm";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { itemCreationValidation } from "../../components/validations/DeductionCreation";
import { errorActions } from "../../store/error-slice";
import Modal from "../../components/Modal";

const DeductionItem = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [editItem, setEditItem] = useState({});
  const [editTax, setEditTax] = useState({});

  //drawer
  const [tab, setTab] = useState(1);
  const [drawerTab, setDrawerTab] = useState(1);

  //flags
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  //errors
  const errorState = useSelector(
    (state) => state.error.deductItemCreationErrors,
  );

  // tab ref
  const itemCreationRef = useRef();
  const taxCreationRef = useRef();

  // search ref
  const codeRef = useRef(null);
  const nameRef = useRef(null);
  const chargeRef = useRef(null);
  const prefixRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  //search state
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [category, setCategory] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [defaultUnit, setDefaultUnit] = useState("");
  const [packageType, setPackageType] = useState("");

  // dropdown
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
  const [itemOccurrenceOptions, setItemOccurrenceOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);

  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setIsSearchLoading(true);

      //new

      const {
        active,
        status,
        item_type: itemTypeOpt,
        item_category: itemCategoryOpt,
        item_occurrence: itemOccurrenceOpt,
      } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
        { key: "item_type" },
        { key: "item_category" },
        { key: "item_occurrence" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);
      setItemTypeOptions(itemTypeOpt);
      setItemCategoryOptions(itemCategoryOpt);
      setItemOccurrenceOptions(itemOccurrenceOpt);

      setIsLoading(false);
      setIsSearchLoading(false);
    })();
  }, []);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
    setEditMode(false);
    setEditItem(null);
    setDrawerTab(1);
    dispatch(errorActions.clearDeductItemError());
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const logTaxItems = (e) => {
    e.preventDefault();
    // Retrieve tax form data
    const taxData = taxCreationRef.current.getData();

    console.log("📌 Retrieved Tax Data from ItemTaxForm:", taxData);

    // Extract selectedTaxes from taxData (ensure it is an array)
    const taxItems = Array.isArray(taxData?.selectedTaxes)
      ? taxData.selectedTaxes
      : [];

    if (taxItems.length === 0) {
      console.log("❌ No tax items found.");
      return;
    }

    // Log each tax item
    taxItems.forEach((tax, index) => {
      console.log(`🔹 Tax Item ${index + 1}:`, tax);
    });

    console.log("✅ Total Tax Items Retrieved:", taxItems.length);
  };

  const handleSubmit = async (e, bypassDeleteCheck) => {
    e.preventDefault();
    if (!bypassDeleteCheck && itemCreationRef.current.isDeletedActive()) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setIsSubmitLoading(true);

    dispatch(errorActions.clearDeductItemError());

    // ✅ Retrieve Item Form Data
    const itemData = itemCreationRef.current.getData() || {}; // Ensure it's not undefined
    console.log("the item data: ", itemData);

    // ✅ Retrieve Tax Form Data
    const taxData = taxCreationRef.current.getData() || {};
    const taxItems = Array.isArray(taxData?.selectedTaxes)
      ? taxData.selectedTaxes
      : [];

    const deductItemErrors = itemCreationValidation(itemData);
    if (Object.keys(deductItemErrors).length > 0) {
      dispatch(
        errorActions.validateDeductItemCreation({ deductItemData: itemData }),
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Item", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }

    // ✅ Construct payload for DeductionItemRequest
    const deductionItemPayload = {
      temId: itemData.temId || null, // For create, it's null; for update, it's the existing ID
      temReference: itemData.temReference || "", // Ensure it's not undefined
      temCompany: itemData.temCompany || 1, // ✅ Ensure temCompany is always set
      temType: itemData.temType || null,
      temCategory: itemData.temCategory || null,
      temName: itemData.temName || "",
      temPrefix: itemData.temPrefix || "40", // ✅ Default "40" if missing
      temCounter: itemData.temCounter || 1,
      temOccurrence: itemData.temOccurrence || null,
      temDescription: itemData.temDescription || "",
      temCharge: itemData.temCharge || null,
      temSupplier: itemData.temSupplier || null,
      temWarranty: itemData.temWarranty || null,
      temStatus: itemData.temStatus || 2, // ✅ Default status
      temActive: itemData.temActive || 1, // ✅ Default active
      temUnit: itemData.temUnit || null,
      temPrice: itemData.temPrice || "0", // ✅ Default "0" if missing
      temPackageType: itemData.temPackageType || null,
      temExpireDistance: itemData.temExpireDistance || null,
      temDistanceType: itemData.temDistanceType || null,
      temExpireDuration: itemData.temExpireDuration || null,
      temDurationType: itemData.temDurationType || null,
      author: user.username, // ✅ Dynamically set from the logged-in user
      itemTaxReq: taxItems.map((tax) => ({
        chtId: tax.chtId || null, // ✅ Send existing ID in edit mode, otherwise null
        chtCode: tax.chtCode || null, // ✅ No code needed
        chtReferance: tax.itemReference || "", // ✅ Ensure it's not undefined
        chtCompany: 1, // ✅ Always set to 1
        chtCharge: itemData.temId || null, // ✅ Must match item ID
        chtTax: tax.itemTax || null,
        chtStatus: tax.status || 2, // ✅ Default status
        chtActive: tax.active || 1, // ✅ Default active
        chtOpeType: 18,
        chtCustomer: tax.chtCustomer || null,
        chtDefault: tax.chtDefault || false,
        author: user.username, // ✅ Set author
      })),
    };

    console.log("🚀 Final Payload:", deductionItemPayload);

    try {
      if (editMode) {
        // **UPDATE EXISTING ITEM**
        await updateDeductItem(deductionItemPayload);
        toast.success("Item updated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        // **CHECK IF ITEM NAME ALREADY EXISTS**
        const isItemAvailable = await deductionItemByName(itemData.temName);
        if (isItemAvailable.length > 0) {
          setIsSubmitLoading(false);
          toast.error("Item Name Already Added", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        }

        // **CREATE NEW ITEM**
        await addDeductItem(deductionItemPayload);
        toast.success("Item added successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    } catch (error) {
      console.error("❌ Error saving item:", error);
      toast.error("Error occurred while saving item!", {
        autoClose: 5000,
        containerId: "Main",
      });
    }

    reset();
    setIsSubmitLoading(false);
    setIsDrawerOpen(false);
  };

  const reset = () => {
    itemCreationRef.current.resetForm();
    setEditMode(false);
    setEditItem(null);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setSearchClicked(true);
    setSearchSubmitLoading(true);

    const response = await searchDeductItems({
      temCode: codeRef.current.value,
      temName: nameRef.current.value,
      temType: itemType,
      temCategory: category,
      temCharge: chargeRef.current.value,
      temSupplier: "-2",
      temPrefix: prefixRef.current.value,
      temUnit: defaultUnit,
      temPackageType: packageType,
      temFrom: fromDateRef.current.value,
      temTo: toDateRef.current.value,
      temStatus: status,
      temActive: active,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    setStatus(null);
    setActive(null);
    setDefaultUnit(null);
    setPackageType(null);
    setCategory(null);
    setItemType(null);
    codeRef.current.reset();
    nameRef.current.reset();
    chargeRef.current.reset();
    prefixRef.current.reset();
    fromDateRef.current.reset();
    toDateRef.current.reset();
    setSearchFieldReset(true);
  };

  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
        <Button
          label="Proceed"
          className="ui red button"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            handleSubmit(pendingSubmitEvent, true);
            setPendingSubmitEvent(null);
          }}
        />
      </div>
    </div>
  );
  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Globe size={15} style={{ marginRight: "5px" }} />
            </span>
            Item Search
          </div>
        </div>
        <div
          className="ui primary button"
          style={{
            display: "flex",
            alignItems: "right",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={handleDrawerOpen}
        >
          <i className="plus icon"></i>
          <span>Add</span>
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <Input
                    label="Item Code"
                    placeholder="Item Code"
                    name="itemCode"
                    ref={codeRef}
                  />
                  <Dropdown
                    label="Item Type"
                    options={itemTypeOptions}
                    placeholder="Item Type"
                    style={{ height: "20px" }}
                    value={itemType}
                    onChange={(e, data) => {
                      setItemType(data.value);
                    }}
                  />
                  <Input
                    label="Item Name"
                    placeholder="Item Name"
                    name="itemName"
                    ref={nameRef}
                  />
                  <Input
                    label="Item Charge"
                    placeholder="Item Charge"
                    name="ItemCharge"
                    type="number"
                    min={0}
                    ref={chargeRef}
                  />
                </div>

                <div className="four fields">
                  <Input
                    label="Finance Code"
                    placeholder="Finance Code"
                    name="itemPrefix"
                    ref={prefixRef}
                  />
                  <SearchDropdown
                    placeholder={"Default Unit"}
                    key={1}
                    threshold={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onResultSelect={(data) => setDefaultUnit(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "unit_type",
                      value: "",
                    }}
                    label="Default Unit"
                  />
                  <SearchDropdown
                    placeholder={"Default Package Type"}
                    key={1}
                    threshold={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onResultSelect={(data) => setPackageType(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "package_type",
                      value: "",
                    }}
                    label="Default Package Type"
                  />
                  <Dropdown
                    label="Category"
                    options={itemCategoryOptions}
                    placeholder="Category"
                    style={{ height: "20px" }}
                    value={category}
                    onChange={(e, data) => {
                      setCategory(data.value);
                    }}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                  <Input
                    label="from Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "temId",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "temCode",
                  },
                  {
                    headerName: "Type",
                    field: "typeName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Name",
                    field: "temName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Default Unit",
                    field: "uniName",
                  },
                  {
                    headerName: "Default Package Type",
                    field: "pkgName",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await deductionItemById(props.data.temId);
                  console.log("-------");
                  console.log(response);
                  setEditItem(response);
                  setEditTax(response[0].itemTaxDetails || []);
                  setEditMode(true);
                  setDrawerTab(1);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <>
              <div
                className="cluster-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                {/*<h3>Cluster Code: {editCluster?.cluster?.clnCode}</h3>*/}
              </div>
            </>
          ) : null
        }
        body={
          <>
          <form className="drawer-content">
            {" "}
            {/*onSubmit={handleSubmit}*/}
            <div style={{ width: "60vw", boxShadow: "none" }}>
              <div className="ui top attached tabular menu">
                <div
                  className={`item ${drawerTab === 1 ? "active" : ""}`}
                  onClick={() => {
                    setDrawerTab(1);
                  }}
                >
                  <span>
                    <Globe
                      size={15}
                      style={{
                        marginRight: "5px",
                        color: `${
                          Object.keys(errorState.deductItemCreationErrors)
                            .length !== 0
                            ? "#e0b4b4"
                            : ""
                        }`,
                      }}
                    />
                  </span>
                  <label
                    style={{
                      color: `${
                        Object.keys(errorState.deductItemCreationErrors)
                          .length !== 0
                          ? "#e0b4b4"
                          : ""
                      }`,
                    }}
                  >
                    Item
                  </label>
                </div>
                <div
                  className={`item ${drawerTab === 2 ? "active" : ""}`}
                  onClick={() => setDrawerTab(2)}
                >
                  <span>
                    <Globe
                      size={15}
                      style={{
                        marginRight: "5px",
                      }}
                    />
                  </span>
                  <label>Tax</label>
                </div>
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 1 ? "block" : "none" }}
              >
                <DeductionItemForm
                  ref={itemCreationRef}
                  errors={errorState.deductItemCreationErrors}
                  editMode={editMode}
                  currentValues={editMode ? editItem : null}
                  isLoading={isLoading}
                />
              </div>
              {/* Tax Tab Content */}
              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 2 ? "block" : "none" }}
              >
                <ItemTaxForm
                  ref={taxCreationRef}
                  errors={errorState.taxErrors}
                  editMode={editMode}
                  currentValues={editMode ? editTax : null}
                  isLoading={isLoading}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  padding: "1rem",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  {/* Next Button on Tab 1 */}
                  {drawerTab === 1 && (
                    <Button
                      template="next"
                      onClick={() => {
                        // Validate form data before moving to next tab
                        const deductItemErrors = itemCreationValidation(
                          itemCreationRef.current.getData(),
                        );

                        if (Object.keys(deductItemErrors).length > 0) {
                          // Dispatch validation errors to Redux store
                          dispatch(
                            errorActions.validateDeductItemCreation({
                              deductItemData: itemCreationRef.current.getData(),
                            }),
                          );
                          return; // Stop navigation
                        }
                        // If no errors, proceed to next tab
                        setDrawerTab(2);
                      }}
                    >
                      Next
                    </Button>
                  )}

                  {/* Submit Button on Tab 2 */}
                  {drawerTab === 2 && (
                    <Button
                      type="submit"
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                      editMode={editMode}
                      onClick={handleSubmit}
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
          <Modal ref={deleteWarningRef} closeButton={false} minWidth={"300px"}>
                  {showDeleteWarning && deleteWarningModal}
                </Modal>
          </>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};

export default DeductionItem;
